export interface ProjectEditValue {
  ref: string;
  name: string;
}

export function orderProjectUpdateBody(edit: ProjectEditValue, canEditRef: boolean) {
  return {
    ...(canEditRef ? { partnerProjectRef: edit.ref.trim() || null } : {}),
    partnerProjectName: edit.name.trim() || null,
  };
}
